/// <reference path="modules/detailed-wipreport/components/detailed-wipreport.component.ts" />
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AuthConfig,
  JwksValidationHandler,
  OAuthModule,
  ValidationHandler,
  OAuthModuleConfig
} from 'angular-oauth2-oidc';

import { AppSettings } from './entities/AppSettings';



import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { enableProdMode } from '@angular/core';

enableProdMode();


//PrimeNG


//import { authConfigFactory } from './shared/components/auth/auth-config-factory';
import { AppSettingsService } from './services/app-settings/app-settings.service';
import { HomeComponent } from './modules/app/pages/home/home.component';
import { BASE_URL } from './modules/shared/components/app.tokens';
import { SharedModule } from './modules/shared/shared.module';
import { MfSidebarComponent } from './modules/shared/components/mf-sidebar/mf-sidebar.component';
import { MasterDetailComponent } from './framework/components/mf-master-detail/mf-master-detail.component';
import { ThemeModule } from './@theme/theme.module';
import { CoreModule } from './@core/core.module';
import { NbThemeModule } from '@nebular/theme';
import { MfNestedFormsComponent } from './framework/components/mf-nested-forms/mf-nested-forms.component';
import { ParticlesModule } from 'angular-particle';
import { MfFiltersComponent } from './framework/components/mf-filters/mf-filters.component';
import { MfBladeComponent } from './framework/components/mf-blade/mf-blade.component';
import { ConfirmationService, DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { MfChromeSupportComponent } from './framework/components/mf-chrome-support/mf-chrome-support.component';
import { PasswordExpiredComponent } from './modules/shared/components/password-expired/password-expired.component';
//import { DetailedWIPReportComponent } from './modules/detailed-wipreport/components/detailed-wipreport.component';

@NgModule({
  entryComponents: [MfChromeSupportComponent, PasswordExpiredComponent],
  declarations: [
    AppComponent,
    HomeComponent,
    MfSidebarComponent,
    MasterDetailComponent,
    MfNestedFormsComponent,
    MfChromeSupportComponent, PasswordExpiredComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ThemeModule.forRoot(),
    NbThemeModule.forRoot(),
    CoreModule.forRoot(),
    SharedModule.forRoot(),
    ParticlesModule,
    //OAuthModule.forRoot()
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['https://localhost:44351', 'http://sad-api.mattafix.net/', 'https://sad-api.mattafix.net/', 'https://test-sad-api.mattafix.net/', 'https://dev-sad-api.mattafix.net/', 'https://api.southey.co.za/', 'https://test-api.southey.co.za/'], 
        sendAccessToken: true
      }
    })
  ],
  providers: [
    {
      provide: BASE_URL, useValue: 'https://localhost:44351',
    }, ConfirmationService, DialogService, DynamicDialogRef, DynamicDialogConfig
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
